/*
 * @Author: Jacky Wijaya
 * @Date: 2019-08-14 13:19:25
 * @Last Modified by: jekiwijaya
 * @Last Modified time: 2019-09-16 19:46:30
 */

import React from 'react';
import tinycolor from 'tinycolor2';
import View from '../../../common/components/basic/View';
import Text from '../../../common/components/basic/Text';

import Image from '../../../common/components/basic/Image';
import LayoutProvider from '../../../common/utils/styles/layout/LayoutProvider';
import useTheme from '../../../common/utils/styles/theme/useTheme';
import { MaxWidth, MinWidth } from '../../../common/utils/styles/css/Media';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

const IconShare = ({ className = undefined }) => (
  <img
    width={14}
    height={14}
    className={className}
    css={css`
      opacity: 0.5;
    `}
    src={require('./new-tab-icon.png')}
  />
);

const LinkContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: ${({ theme: { colors } }) => colors.light.primary};
`;

const LinkButton = ({ children, link }) => (
  <a
    href={link}
    target="_blank"
    css={css`
      flex: 1;
      padding: 10px 12px;
      border: 0.5px solid
        ${({ theme: { colors } }) =>
          tinycolor(colors.dark.light)
            .setAlpha(0.15)
            .toString()};
    `}
  >
    {children}
  </a>
);

export default function PartnerExchangeItem({ articleLink, link, image, description }) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  return (
    <LayoutProvider value={{ text: { fontSize: 16 } }}>
      <View
        backgroundColor={colors.light.primary}
        css={css`
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 350px;
          ${MaxWidth.md`
            width: auto;
            flex: 1 1 100%;
          `}
          min-height: 275px;
          :hover {
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
          }
          transition: all ease-in-out 0.2s;
          margin: 10px;
        `}
      >
        <a
          href={link}
          target="_blank"
          css={css`
            flex: 1;
            padding: 40px;
          `}
        >
          <IconShare
            css={css`
              position: absolute;
              right: 16px;
              top: 16px;
            `}
          />
          <Image
            url={image}
            ratio={290 / 100}
            css={`
              padding: 0px 30px;
            `}
          />
          <Text>{description}</Text>
        </a>
        <LinkContainer>
          <LinkButton link={articleLink}>
            {t('partner.exchange.article_link.label', 'Article')}
          </LinkButton>
          <LinkButton link={link}>{t('partner.exchange.link.label', 'Exchange Link')}</LinkButton>
        </LinkContainer>
      </View>
    </LayoutProvider>
  );
}
